import { createSelector } from 'reselect';

export const getSelectedBoundary = createSelector(
  (state) => state.boundaries.get('selectedBoundaryId'),
  (state) => state.user.get('boundaries'),
  (state) => state.boundaries.get('boundaries'),
  (state) => state.boundaries.get('tempBoundaries'),
  (selectedBoundaryId, userBoundaries, boundaries, tempBoundaries) => {
    let selectedBoundary;
    if (selectedBoundaryId) {
      if (userBoundaries) {
        selectedBoundary = userBoundaries.get(selectedBoundaryId);
        if (selectedBoundary) return selectedBoundary;
      }
      if (boundaries) {
        selectedBoundary = boundaries.get(selectedBoundaryId);
        if (selectedBoundary) return selectedBoundary;
      }
      if (tempBoundaries) {
        selectedBoundary = tempBoundaries.get(selectedBoundaryId);
        if (selectedBoundary) return selectedBoundary;
      }
    }
    return selectedBoundary;
  },
);

export const getBoundaries = (state) => state.boundaries.get('boundaries');

export const getTempBoundaries = (state) => state.boundaries.get('tempBoundaries');

export const getSelectedBoundaryId = (state) => state.boundaries.get('selectedBoundaryId');

export const getSelectedSecondaryBoundariesIds = (state) => state.boundaries.get('selectedSecondaryBoundariesIds');

export const getTempPolygon = (state) => state.boundaries.get('tempPolygon');

export const getTempBoundariesName = (state) => state.boundaries.get('tempBoundariesName');
